import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/firestore";
import {AccountModel} from "../../models/accounts/account";
import {Notification} from "../../models/accounts/notification";
import {AccountLocate} from "../../models/accounts/account-locate";
import {Interest} from "../../models/system/branch-collection/interest";
import {Role} from "../../models/accounts/role";
import {AngularFireAuth} from "@angular/fire/auth";
import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {AngularFireStorage} from "@angular/fire/storage";
import {Image} from "../../models/image/image";
import * as firebase from "firebase";
import {error} from "util";


function firebaseSerialize<T>(object: T) {
  return JSON.parse(JSON.stringify(object));
}

@Injectable({
  providedIn: 'root'
})
export class AccountServiceService {

    private imageCollection: AngularFirestoreCollection<Image>;
  private collection: AngularFirestoreCollection<AccountModel>;
  collectionName = 'accounts';
  notifyDoc: any;
  deleteImageSubscription: any;
  generateSingleImageSub: any;
  constructor(private firestore: AngularFirestore,
              private afAuth: AngularFireAuth,
              private storage: AngularFireStorage) {
    this.collection = this.firestore.collection(this.collectionName);
  }

  checkCompletedStatus(): boolean
  {
    return false;
  }

  createAccount(model: AccountModel, uid) {
    return this.firestore.collection(this.collectionName).doc(uid).set(Object.assign({}, model));
  }
  addDocNotifyToAccount(model: Notification, uid) {
    // tslint:disable-next-line:max-line-length
    return this.firestore.collection(this.collectionName).doc(uid).ref.collection('notifications').add(Object.assign({}, model));
  }

  addLocateToAccount(model: AccountLocate, uid) {
    // tslint:disable-next-line:max-line-length
    return this.firestore.collection(this.collectionName).doc(uid).ref.collection('locate').add(Object.assign({}, model));
  }

  addInterestToAccount(model: Interest, uid) {
    // tslint:disable-next-line:max-line-length
    return this.firestore.collection(this.collectionName).doc(uid).ref.collection('interestFollow').add(Object.assign({}, model));
  }

  addRoleToAccount(model: Role, uid) {
    // tslint:disable-next-line:max-line-length
    return this.firestore.collection(this.collectionName).doc(uid).ref.collection('roles').add(Object.assign({}, model));
  }





  getDetails(id: string): Observable<AccountModel> {
   // return this.firestore.collection(this.collectionName).snapshotChanges();

    return this.collection
        .doc<AccountModel>(id)
        .snapshotChanges()
        .pipe(
            // We want to map the document into a Typed JS Object
            map(doc => {
              // Only if the entity exists should we build an object out of it
              if (doc.payload.exists) {
                const data = doc.payload.data() as AccountModel;
                const payloadId = doc.payload.id;
                return { id: payloadId, ...data };
              }
            })
        );
  }

  dataList(): Observable<AccountModel[]> {
    return this.collection.snapshotChanges().pipe(
        // Again we want to build a Typed JS Object from the Document
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as AccountModel;
            data.id = a.payload.doc.id;
            return data;
          });
        })
    );
  }


  update(model: AccountModel) {
     this.afAuth.user.subscribe((data => {
       this.firestore.doc(this.collectionName + '/' + data.uid).update(model).then(doc => {
           console.log(doc);
         return doc;
       }).catch(error => {
         throw new error('failed');
       });
 }));
  }

  updatePromise(model: AccountModel): Promise<AccountModel> { // güncellerken model üzerinden günceller ve tamamını değiştirir
    return new Promise<AccountModel>((resolve, reject) => {
      this.collection
          .doc<AccountModel>(model.id as string)
          .set(firebaseSerialize(model))
          .then(() => {
            resolve({
              ...model,
            });
          });
    });
  }


    addImageToDB(image: Image) {
        //Create an ID for document
        //const id = this.firestore.createId();



        this.afAuth.user.subscribe((data => {
            //Set document id with value in database

            this.firestore.collection(this.collectionName).doc(data.uid).ref.collection('image').add(Object.assign({}, image)).then(resp => {
                console.log(resp);
            }).catch(error => {
                console.log("error " + error);
            });
        }));

    }

    generateSingleImage(image: Image): Promise<boolean> {
        return new Promise((resolve, reject) => {


            this.generateSingleImageSub = this.afAuth.user.pipe(take(1)).subscribe((data => {
                this.firestore.doc(this.collectionName + '/' + data.uid).update(image).then(doc => {
                    this.generateSingleImageSub.unsubscribe();
                    resolve(true);
                }).catch(error => {
                    throw new error('failed');
                    reject(false);
                });
            }));
        });
        this.generateSingleImageSub.unsubscribe();

       // this.generateSingleImageSub.unsubscribe();
       // console.log(this.generateSingleImageSub);
       // return this.generateSingleImageSub.closed;
    }

    getSingleImage(id: string): Observable<Image>  {
        return this.collection
            .doc<Image>(id)
            .snapshotChanges()
            .pipe(
                // We want to map the document into a Typed JS Object
                map(doc => {
                    // Only if the entity exists should we build an object out of it
                    if (doc.payload.exists) {
                        const data = doc.payload.data() as Image;
                        const payloadId = doc.payload.id;
                        return { id: payloadId, ...data };
                    }
                })
            );
    }

    deleteImageFromStorageWithRef(refUrl: string): Promise<boolean> {
        console.log(refUrl);
        return new Promise((resolve, reject) => {
            if (refUrl) {
                return this.storage.storage.refFromURL(refUrl).delete().then(() => {
                    resolve(true);
                }).catch(error => {
                    console.log(error);
                    reject(false);
                });
            }
            reject(false);
        });


    }

    deleteImageFromDatabase(uid: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.firestore.collection(this.collectionName).doc(uid).set({
                ['profileImageFilepath']: firebase.firestore.FieldValue.delete(),
                ['profileImageName']: firebase.firestore.FieldValue.delete(),
                ['profileImageSize']: firebase.firestore.FieldValue.delete()

            }, { merge: true }).then(() => {
                resolve(true);
            }).catch(() => {
                throw new error('failed');
                reject(false);
            });
        });

    }
    getImages() {

    }


}
